import Actions from "views/Actions/Actions.jsx";
import JobApplication from "views/JobApplication/JobApplication.jsx";
import Brokers from "views/Brokering/Brokers.jsx";
import Orders from "views/Brokering/Orders.jsx";
import Profile from "views/Profile/Profile.jsx";
import PendingActions from "views/Admin/PendingActions.jsx";
import Users from "views/Admin/Users.jsx";
import pagesRoutes from "./pages.jsx";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import Apps from "@material-ui/icons/Apps";
// import ContentPaste from "@material-ui/icons/ContentPaste";

import Place from "@material-ui/icons/Place";
import Timeline from "@material-ui/icons/Timeline";
import Ship from "../views/Ship/Ship.jsx";
import PlaceOrder from "../views/Customer/PlaceOrder.jsx";
import CurrentOrders1 from "../views/Customer/CurrentOrders1.jsx";
import Lanes from "../views/Lanes/Lanes.jsx";
import Rates from "../views/Rates/Rates.jsx";
import FeedForms from "../components/Forms/FeedForms.jsx"
import Dispatch from "../views/Dispatch/Dispatch.jsx";
import Carriers from "../views/Admin/Carriers.jsx";
import DispatchedOrders from "../views/Dispatch/DispatchedOrders.jsx";
import DispatchedOrdersDriver from "../views/Driver/DispatchedOrders.jsx";
import ConfirmedOrders from "../views/Dispatch/ConfirmedOrders.jsx";
import DispatchedOrders1 from "../views/Driver/DispatchedOrders1.jsx";

export default [ 
  {
    collapse: true,
    admin: true,
    path: "/admin",
    name: "Admin",
    icon: DashboardIcon,
    views: [
      { path: "/admin/users", name: "Users", component: Users },   
    ]
  }, 
  { path: "/profile", name: "Profile", component: Profile },   
  { path: "/actions", name: "Dashboard", component: Actions }, 
  { path: "/place-order", shipper: true, name: "Place Order", component: FeedForms },    
  //{ path: "/feed", customer: true, name: "Form", component: FeedForms },    
  { path: "/current-orders", shipper: true, name: "Current Orders", component: CurrentOrders1 },
  { path: "/past-orders", shipper: true, name: "Past Orders", component: CurrentOrders1 },
  { path: "/lanes", shipper: true, name: "Lane Benchmarks", component: Lanes },    
  {
    collapse: true,
    user: true,
    path: "/dispatch",
    name: "Dispatch",
    icon: DashboardIcon,
    state: "openLearn",
    views: [
      { path: "/dispatch/pending-orders", name: "Pending Orders", component: Dispatch },   
      { path: "/dispatch/disptached-orders", name: "Dispatched Orders", component: DispatchedOrders },
      { path: "/dispatch/confirmed-orders", name: "Confirmed Orders", component: ConfirmedOrders },
    ]
  }, 
  //{ path: "/routing", user: true, name: "Dispatch", component: Dispatch },    
  { path: "/financials", user: true, name: "Financials", component: Profile },    
  { path: "/hr", user: true, name: "HR", component: Profile },    
  { path: "/driver", carrier: true, name: "Driver", component: DispatchedOrders1 },
  { path: "/rates", carrier: true, name: "Rate Matrix", component: Rates },
  //{ path: "/carriers", name: "Carriers", component: Carriers },
  // {
  //   collapse: true,
  //   path: "/assess",
  //   name: "Assess",
  //   icon: DashboardIcon,
  //   state: "openAssess",
  //   views: [
  //     { path: "/assess/assessment", name: "Take the Assessment", component: Profile },   
  //     { path: "/assess/path", name: "Path to Purposeful Leadership", component: Profile },
  //     { path: "/assess/purpose", name: "Purpose Embraced Path", component: Profile },
  //     { path: "/assess/stakeholders", name: "Stakeholders Engaged Path", component: Profile },
  //     { path: "/assess/strategy", name: "Strategy Aligned Path", component: Profile },
  //     { path: "/assess/actions", name: "Actions Aligned Path", component: Profile }
  //   ]
  // }, 
  // {
  //   collapse: true,
  //   path: "/grow",
  //   name: "Grow",
  //   icon: DashboardIcon,
  //   state: "openGrow",
  //   views: [
  //     { path: "/grow/articles", name: "Articles Library", component: Profile },   
  //     { path: "/grow/tudies", name: "Research Studies Library", component: Profile },   
  //     { path: "/grow/books", name: "Books Library", component: Profile },   
  //     { path: "/grow/share", name: "Share a Resource", component: Profile },   
  //     { path: "/grow/consultants", name: "Directory of Consultants", component: Profile },   
  //     { path: "/grow/professionals", name: "Directory of Consultants", component: Profile },   
  //     { path: "/grow/courses", name: "Upcoming Courses", component: Profile },
  //     { path: "/grow/archive", name: "Course Archive", component: Profile },
  //     { path: "/grow/suggest", name: "Suggest a Course or Webinar", component: Profile }
  //   ]
  // }, 
  // {
  //   collapse: true,
  //   path: "/connect",
  //   name: "Connect",
  //   icon: DashboardIcon,
  //   state: "openConnect",
  //   views: [
  //     { path: "/connect/communities", name: "Communities of Interest", component: Profile },   
  //     { path: "/connect/blog", name: "Blog", component: Profile },
  //     { path: "/connect/newsletter", name: "Newsletter", component: Profile },     
  //     { path: "/connect/radio", name: "Radio", component: Profile },     
  //     { path: "/connect/group-calls", name: "Group Calls", component: Profile },     
  //     { path: "/connect/group-calls", name: "Affliates", component: Profile },
  //     { path: "/connect/member", name: "Become a Member", component: Profile }, 
  //     { path: "/connect/partner", name: "Become a Partner", component: Profile }, 
  //     { path: "/connect/champion", name: "Become a Champion", component: Profile },
  //     { path: "/connect/sponsor", name: "Become a Sponsor or Donor", component: Profile },
  //     { path: "/connect/advocate", name: "Become an Advocate", component: Profile },   
  //     { path: "/connect/marketplace", name: "Talent Marketplace", component: Profile }     
    
  //   ]
  // }, 
  // {
  //   collapse: true,
  //   path: "/about",
  //   name: "About",
  //   icon: DashboardIcon,
  //   state: "openAbout",
  //   views: [
  //     { path: "/about/who-we-are", name: "Who we Are", component: Profile },   
  //     { path: "/about/champions", name: "Our Champions", component: Profile },  
  //     { path: "/about/bbard", name: "Our Board Members", component: Profile },     
  //     { path: "/about/sponsors", name: "Our Sponsors", component: Profile },     
  //     { path: "/about/memmbers", name: "Member Directory", component: Users }     
  //   ]
  // }, 
  // { path: "/contact", name: "Contact", component: Profile },    
  
  // { path: "/dashboard/apply", name: "Job Application", component: JobApplication },
  // {
  //   collapse: true,
  //   path: "/admin",
  //   name: "Admin",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/field",
  //   name: "Field",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/communications",
  //   name: "Communications",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/volunteers",
  //   name: "Volunteers",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/political",
  //   name: "Political",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/fundraising",
  //   name: "Fundraising",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/treasurer",
  //   name: "Treasurer",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/legal",
  //   name: "Legal",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/technology",
  //   name: "Technology",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/scheduling",
  //   name: "Scheduling",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // }

];





// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx